import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
	AES_Encryption,
	GetDataFromServer,
	SetMedicalExpensesJSONParameter,
	SetParameter,
	ValidatePhone,
} from "../../../../hooks";
import { APP_ID, REGEX, SERVER_URL } from "../../../../constants/index";
import { Modal, Col, Row, Container, Table } from "react-bootstrap";

import Success_Img from "../../../../assets/images/pay_success.png";
import Error_Img from "../../../../assets/images/error.png";
import AlertModal from "../../../atoms/AlertModal";
import Loader from "../../../atoms/Loader";
import Calendario from "../../../atoms/Calendario";
import { useAlert } from "react-alert";
import { FaPlus } from "react-icons/fa";
import { ValidateAll } from "./modal-validation.helper";

const Default_Data = {
	name: "",
	e_mail: "",
	id_gender: parseInt(1),
	id_cus_parents: 1,
	birthday: "",
	nacimiento: "",
	phone: "",
	zip_code: "",
	alias: "",
	tipo_seguro: "",
	el_seguro: 1,
	algun: 0,
	physical_person: 0,
	business_name: "",
	beneficiario: [],
	suma_asegurada: 0,
};
const AccidentForm = ({
	Heading = "Cotizador de Accidentes Personales",
	type,
	img,
	isImage,
}) => {
	const alert = useAlert();
	const [errors, setErrors] = useState({});
	const [benef_err, setBenefErr] = useState({});
	const [disabled, setDisabled] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [wannaDelete, setWannaDelete] = useState(false);
	const [wannaAdd, setWannaAdd] = useState(false);
	const [isAllBeneficiary, setAllBeneficiary] = useState(false);

	const [currentBenef, setCurrentBenef] = useState({
		name: "",
		nacimiento: "",
		id_gender: "1",
		id_cus_parents: "4",
	});
	const [activeRow, setActiveRow] = useState(null);

	const [modalAlert, setAlert] = useState({
		show: false,
		reason: null,
		img: null,
		heading: "",
		content: "",
		btn: "",
		subContent: "",
	});
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(Default_Data);

	const onClickHandler = () => {
		let ERR = {};
		let { name, e_mail, phone, zip_code, birthday } = data;

		if (
			name.length > 0 &&
			e_mail.length > 0 &&
			phone.length > 0 &&
			zip_code.length > 0 &&
			!isNaN(new Date(birthday).getTime())
		) {
			if (
				REGEX["phone"].test(phone) &&
				phone.length <= 10 &&
				ValidatePhone(phone, 10) &&
				REGEX["number"].test(zip_code) &&
				REGEX["text"].test(name) &&
				REGEX["email"].test(e_mail)
			) {
				return true;
			}
			if (!REGEX["phone"].test(phone) || !ValidatePhone(phone, 10)) {
				ERR = { ...ERR, phone: true };
				setErrors({ ...errors, ...ERR });
				alert.show("el número de teléfono no está en el formato correcto");
				return false;
			}

			if (!REGEX["number"].test(zip_code)) {
				ERR = { ...ERR, zip_code: true };
				setErrors({ ...errors, ...ERR });
				alert.show("el código postal debe ser un número");
				return false;
			}

			if (!REGEX["text"].test(name)) {
				ERR = { ...ERR, name: true };
				setErrors({ ...errors, ...ERR });
				alert.show("valor deve estar em string");
				return false;
			}

			if (!REGEX["email"].test(e_mail)) {
				ERR = { ...ERR, e_mail: true };
				setErrors({ ...errors, ...ERR });
				alert.show("el correo electrónico no tiene el formato correcto");
				return false;
			}
		} else {
			if (name.length == 0) {
				ERR = { ...ERR, e_mail: true };
			} else {
				let newErr = errors;
				delete newErr["name"];
				setErrors(newErr);
			}
			if (e_mail.length == 0) {
				ERR = { ...ERR, e_mail: true };
			} else {
				let newErr = errors;
				delete newErr["e_mail"];
				setErrors(newErr);
			}
			if (phone.length == 0) {
				ERR = { ...ERR, phone: true };
			} else {
				let newErr = errors;
				delete newErr["phone"];
				setErrors(newErr);
			}
			if (zip_code.length == 0) {
				ERR = { ...ERR, zip_code: true };
			} else {
				let newErr = errors;
				delete newErr["zip_code"];
				setErrors(newErr);
			}

			if (isNaN(new Date(birthday).getTime())) {
				ERR = { ...ERR, birthday: true };
			} else {
				let newErr = errors;
				delete newErr["birthday"];
				setErrors(newErr);
			}

			setErrors({ ...errors, ...ERR });
			alert.show("Por favor llene todos los campos.");
			return false;
		}

		return false;
	};

	const ProcessToQuote = async () => {
		setErrors({});
		let url = SERVER_URL + "bts_ws_quote_salud.aspx";
		let param = "";
		const {
			name,
			id_gender,
			e_mail,
			nacimiento,
			phone,
			id_cus_parents,
			zip_code,
			alias,
			suma_asegurada,
		} = data;
		let date = new Date(nacimiento);
		if (type == "medical-expense") {
			param = SetMedicalExpensesJSONParameter(data, APP_ID);
			url = `${SERVER_URL}bts_ws_quote_GMM_V2.aspx`;
		} 
		else if (type == "medical-expense-group")
			param = SetParameter(
				{
					name,
					id_gender,
					e_mail,
					phone,
					zip_code,
					alias,
					id_tipo_seguro: 1005,
					nacimiento:
						date.getFullYear() +
						"-" +
						("0" + (date.getMonth() + 1)).slice(-2) +
						"-" +
						("0" + date.getDate()).slice(-2),
					// id_cus_parents
				},
				APP_ID,
			);
		else if (type == "company_accident")
			param = SetParameter(
				{
					name,
					id_gender,
					e_mail,
					day: `0${date.getDate()}`.slice(-2),
					month: `0${date.getMonth() + 1}`.slice(-2),
					year: date.getFullYear(),
					phone,
					id_cus_parents,
					zip_code,
					alias,
					id_tipo_seguro: 1020,
				},
				APP_ID,
			);
		else if (type == "accident") {

			if(Number(suma_asegurada) == 0) {
				setAlert({
					show: true,
					heading: "iUps, parece que hubo un error!",
					content: "Por favor verifica que los dalos sean los correctos.",
					btn: "Aceptar",
				});
				return
			}

			param = SetParameter(
				{
					name,
					id_gender,
					e_mail,
					nacimiento:
						date.getFullYear() +
						"-" +
						("0" + (date.getMonth() + 1)).slice(-2) +
						"-" +
						("0" + date.getDate()).slice(-2),
					phone,
					id_cus_parents,
					zip_code,
					alias,
					suma_asegurada,
					id_tipo_seguro: 1020,
				},
				APP_ID,
			);
		}

		setLoading(true);
		GetDataFromServer(url, AES_Encryption(param), (err, resp) => {
			if (err) {
				setLoading(false);

				setAlert({
					show: true,
					heading: "iUps, parece que hubo un error!",
					content:
						err?.data?.message ||
						"Por favor verifica que los dalos sean los correctos.",
					img: Error_Img,
					btn: "Aceptar",
				});
			}
			if (resp) {
				setLoading(false);
				setData(Default_Data);
				setAlert({
					show: true,
					heading: "¡Gracias por tu confianza!",
					content: "Recibimos tu solicitud.",
					subContent:
						"En breve uno de los asesores y gurús de tranquilidad te contactará para hacerte llegar tu información.",
					img: Success_Img,
					btn: "Aceptar",
				});
			}
		});
	};
	const formChangeHandler = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		let elem_type = e.target.type;
		if (name == "name") {
			elem_type = "text";
		} else if (name == "phone") {
			elem_type = "phone";
		} else if (name == "e_mail") {
			elem_type = "email";
		} else if (name == "zip_code") {
			elem_type = "number";
		} else if (name == "birthday") {
			elem_type = "date";
		} else if (name === "tipo_seguro") {
			elem_type = "select";
		} else if (type == "nacimiento") {
			elem_type = "date";
		}

		if (!ValidateAll(elem_type, value)) {
			setErrors({ ...errors, [name]: true });
		} else {
			let newErr = errors;
			delete newErr[name];
			setErrors(newErr);
		}
		if (name == "id_gender") {
			setData({ ...data, [name]: parseInt(value) });
		}
		if (name == "zip_code") {
			if (value.length < 6) {
				if (value.length == 5) {
					const encryptedString = AES_Encryption(
						SetParameter({ zip_code: value }, APP_ID),
					);
					const url = `${SERVER_URL}bts_ws_get_zip_code_data.aspx`;

					return GetDataFromServer(url, encryptedString, (err, res) => {
						const { response, error_message, error } = err;
						if (error) alert.show(error_message);
						if (response?.length == 0) {
							return setData({
								...data,
								state: "",
								delegation: "",
								[name]: value,
							});
						}
						return setData({
							...data,
							state: [...new Set(response.map((a) => a.estado))][0],
							delegation: [...new Set(response.map((a) => a.municipio))][0],
							[name]: value,
						});
					});
				} else {
					return setData({ ...data, [name]: value });
				}
			}
		} else {
			setData({ ...data, [name]: value });
		}
		if (name === "el_seguro") {
			setCurrentBenef({
				...currentBenef,
				id_cus_parents: value === 1 ? "4" : "",
			});
		}
	};

	const ValidateBeneficiario = (benef) => {
		const { name, id_cus_parents: parentesco, nacimiento } = benef;
		let ERR = {};

		if (name.length > 0 && !isNaN(new Date(nacimiento).getTime())) {
			const age = new Date().getFullYear() - new Date(nacimiento).getFullYear();
			if (REGEX["text"].test(name)) {
				if (parseInt(parentesco) && parentesco == 4 && age > 25) {
					setBenefErr({ ...benef_err, parentesco: true });
					alert.show("la edad debe ser menor a 25 años");
					return false;
				}
				if (!parseInt(parentesco) && parentesco.length === 0) {
					setBenefErr({ ...benef_err, parentesco: true });
					alert.show("Debe llenar todos los campos");
					return false;
				}
				setBenefErr({});
				return true;
			}
			if (!REGEX["text"].test(name)) {
				setBenefErr({ ...benef_err, name: true });
				alert.show("valor deve estar em string");
				return false;
			}
		}
		if (name.length === 0) {
			ERR = { ...ERR, name: true };
		} else {
			let newErr = benef_err;
			delete newErr["name"];
			ERR = { ...ERR, newErr };
		}
		if (isNaN(new Date(nacimiento).getTime())) {
			ERR = { ...ERR, nacimiento: true };
		} else {
			let newErr = benef_err;
			delete newErr["nacimiento"];
			ERR = { ...ERR, newErr };
		}

		setBenefErr({ ...benef_err, ...ERR });
		alert.show("Por favor complete todos los campos para continuar.");
		return false;
	};

	return (
		<Wrapper
			className='p-4'
			style={{
				minHeight: 550,
				background: "#5a68a1",
			}}>
			<div
				className='text-center'
				style={{
					position: "relative",
				}}>
				<Title>{Heading}</Title> &nbsp;{" "}
				{isImage && (
					<img
						style={{
							filter: "invert(1)",
							position: "absolute",
							right: 0,
							top: 0,
							width: "100%",
							maxWidth: 30,
							height: "auto",
						}}
						src={img}
						alt='logo'
					/>
				)}
			</div>
			<Step1
				errors={errors}
				data={data}
				setData={setData}
				disabled={disabled}
				setConfirmModal={setConfirmModal}
				type={type}
				formChangeHandler={formChangeHandler}
				onClickHandler={onClickHandler}
				ProcessToQuote={ProcessToQuote}
			/>

			{/* Modal Alert to show success or error messages */}
			{modalAlert.show && (
				<AlertModal
					heading={modalAlert.heading}
					content={modalAlert.content}
					subContent={modalAlert.subContent}
					img={modalAlert.img}
					btn={modalAlert.btn}
					modalShow={modalAlert.show}
					setModalShow={() => setAlert({ ...modalAlert, show: false })}
				/>
			)}
			{type == "medical-expense" && (
				<>
					{/* Confirm Modal */}
					{confirmModal && !wannaDelete && !isAllBeneficiary && !wannaAdd && (
						<Modal
							backdrop={false}
							show={confirmModal}
							size='md'
							center
							className='delete-modal'>
							<Modal.Body className='pr-5 pl-5 pt-0'>
								<Container
									className='text-center'
									style={{ padding: "10px 0", color: "#5268c2" }}>
									<h1>¿Desea agregar algún beneficiario?</h1>
								</Container>
							</Modal.Body>
							<div style={{ display: "inline-flex" }}>
								<Button
									onClick={() => {
										setConfirmModal(false);
										ProcessToQuote();
									}}
									className='mt-5 mb-5 btn btn-primary'>
									No
								</Button>
								<Button
									onClick={() => {
										setConfirmModal(false);
										setWannaAdd(true);
									}}
									className='mt-5 mb-5 btn btn-primary'>
									Sí
								</Button>
							</div>
						</Modal>
					)}
					{/* Delete Modal */}
					{wannaDelete && !confirmModal && !isAllBeneficiary && !wannaAdd && (
						<Modal
							backdrop={false}
							show={wannaDelete}
							size='md'
							center
							className='delete-modal'>
							<Modal.Body className='pr-5 pl-5 pt-0'>
								<Container
									className='text-center'
									style={{ padding: "10px 0", color: "#5268c2" }}>
									<h1>¿Quieres eliminar un beneficiario?</h1>
								</Container>
							</Modal.Body>
							<div style={{ display: "inline-flex" }}>
								<Button
									onClick={() => {
										setWannaDelete(false);
										setWannaAdd(false);
										setAllBeneficiary(true);
									}}
									className='mt-5 mb-5 btn btn-primary'>
									No
								</Button>
								<Button
									onClick={() => {
										if (wannaDelete) {
											const beneficiario = data.beneficiario.filter(
												(a, i) => i !== activeRow,
											);
											setData({ ...data, beneficiario });
											setActiveRow(null);
											setWannaDelete(false);
											setWannaAdd(false);
											setAllBeneficiary(true);
										}
									}}
									className='mt-5 mb-5 btn btn-primary'>
									Sí
								</Button>
							</div>
						</Modal>
					)}
					{/* All Beneficiaries Modal */}
					{isAllBeneficiary && !confirmModal && !wannaDelete && !wannaAdd && (
						<Modal
							backdrop={false}
							show={isAllBeneficiary}
							className={wannaDelete ? "delete-modal" : ""}
							size='lg'
							center>
							<Modal.Body className='pr-5 pl-5 pt-0'>
								<Container className='text-center text-white'>
									<h1>Beneficiarios</h1>
								</Container>
								{/* render list of all beneficiaries */}
								<RenderAllBeneficiarios
									isRelatedToYou={data.el_seguro == 1}
									data={data}
									setActiveRow={setActiveRow}
									activeRow={activeRow}
									setData={setData}
									setAllBeneficiary={setAllBeneficiary}
									setWannaAdd={setWannaAdd}
									setWannaDelete={setWannaDelete}
								/>
								<Button
									onClick={() => {
										setWannaDelete(false);
										setWannaAdd(false);
										setAllBeneficiary(false);
										ProcessToQuote();
									}}
									style={{ float: "left" }}
									className='mt-5 mb-5 btn btn-primary'>
									Continuar
								</Button>
								<Button
									onClick={() => {
										setWannaDelete(false);
										setWannaAdd(true);
										setAllBeneficiary(false);
									}}
									style={{ float: "right", width: "auto" }}
									className='mt-5 mb-5 btn btn-warning'>
									Agregar más beneficiario
								</Button>
							</Modal.Body>
						</Modal>
					)}
					{/* Add Beneficiary Model */}
					{!wannaDelete && wannaAdd && !confirmModal && !isAllBeneficiary && (
						<Modal
							backdrop={false}
							show={wannaAdd}
							size='lg'
							fullscreen={true}
							center>
							<Modal.Header>
								<h1 style={{ color: "white" }}>Beneficiario</h1>
							</Modal.Header>
							<Modal.Body className='pr-5 pl-5 pt-0'>
								<RenderPayes
									relatedToYou={data.el_seguro == 1}
									current={currentBenef}
									errors={benef_err}
									setErrors={setBenefErr}
									setCurrentBenef={setCurrentBenef}
								/>
								<Button
									onClick={() => {
										setWannaDelete(false);
										setWannaAdd(false);
										setAllBeneficiary(true);
									}}
									style={{ float: "left" }}
									className='mt-5 mb-5 btn btn-primary'>
									Cancelar
								</Button>
								<Button
									onClick={() => {
										const isSuccess = ValidateBeneficiario(currentBenef);
										if (isSuccess) {
											setData({
												...data,
												beneficiario: [...data.beneficiario, currentBenef],
											});

											setCurrentBenef({
												name: "",
												nacimiento: "",
												id_gender: "1",
												id_cus_parents: data.el_seguro == 1 ? "4" : "",
											});
											setWannaAdd(false);
											setWannaDelete(false);
											setAllBeneficiary(true);
										}
									}}
									style={{ float: "right", width: "auto" }}
									className='mt-5 mb-5 btn btn-warning'>
									Agregar Beneficiario <FaPlus />
								</Button>
							</Modal.Body>
						</Modal>
					)}
				</>
			)}
			{/* Loader */}
			{loading && <Loader />}
		</Wrapper>
	);
};

const RenderAllBeneficiarios = ({
	data,
	setData,
	setActiveRow,
	activeRow,
	setAllBeneficiary,
	setWannaAdd,
	setWannaDelete,
	isRelatedToYou,
}) => {
	const handleChange = (e) => {
		const { beneficiario } = data;
		beneficiario[activeRow][e.target.name] = e.target.value;
		setData({ ...data, beneficiario });
	};
	return (
		<TableWrapper>
			<thead>
				<tr>
					<th>#</th>
					<th>Nombre</th>
					<th>Parentesco</th>
					<th>&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				{data.beneficiario.length > 0 ? (
					data.beneficiario.map((benef, i) => (
						<tr key={i}>
							<td>{i + 1}</td>
							<td>
								<input
									type='text'
									name='name'
									value={benef.name}
									onChange={handleChange}
									disabled={activeRow !== i}
								/>
							</td>
							<td>
								{isRelatedToYou ? (
									<div className='custom-select-container'>
										<select
											className='form-control'
											name='id_cus_parents'
											value={benef.id_cus_parents}
											disabled={activeRow !== i}
											onChange={handleChange}>
											<option value={0} disabled selected>
												Seleccione
											</option>
											{["Hijo", "Cónyuge"].map((item, i) => (
												<option
													key={item}
													selected={item === benef.id_cus_parents}
													value={i == 0 ? 4 : 5}>
													{item}
												</option>
											))}
										</select>
										<span className='custom-arrow' />
									</div>
								) : (
									<input
										type='text'
										name='id_cus_parents'
										value={benef.id_cus_parents}
										onChange={handleChange}
										disabled={activeRow !== i}
									/>
								)}
							</td>
							<td style={{ display: "flex", flexDirection: "column" }}>
								<button
									onClick={() => setActiveRow(i)}
									className='mb-1 btn btn-primary'>
									Modificar
								</button>
								<button
									onClick={() => {
										setAllBeneficiary(false);
										setWannaAdd(false);
										setWannaDelete(true);
										setActiveRow(i);
									}}
									className='mb-1 btn btn-primary'>
									Eliminar
								</button>
							</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan={4} rowSpan={4} className='text-center'>
							Aún no se ha agregado ningún Beneficiario ...
						</td>
					</tr>
				)}
			</tbody>
		</TableWrapper>
	);
};
const RenderPayes = ({
	current,
	setCurrentBenef,
	relatedToYou,
	errors,
	setErrors,
}) => {
	const handleUpdateBeneficiario = (e, date) => {
		if (!date) {
			const name = e.target.name;
			const value = e.target.value;
			let elem_type = e.target.type;

			if (name == "id_cus_parents") {
				elem_type = relatedToYou ? "radio" : "text";
			}

			if (!ValidateAll(elem_type, value)) {
				setErrors({ ...errors, [name]: true });
			} else {
				let newErr = errors;
				delete newErr[name];
				setErrors(newErr);
			}
		}
		if (date) {
			current.nacimiento = e;
		} else if (e.target.name === "id_gender_benef") {
			current["id_gender"] = e.target.value;
		} else {
			current[e.target.name] = e.target.value;
		}
		setCurrentBenef({ ...current });
	};

	return (
		<div className='container'>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Nombre</label>
					<input
						className='form-control'
						type='text'
						name='name'
						style={errors.name ? { borderColor: "red" } : {}}
						onChange={handleUpdateBeneficiario}
						value={current.name}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Fecha de Nacimiento</label>
					<Calendario
						name='nacimiento'
						error={errors.nacimiento}
						value={current.nacimiento}
						handleChange={(date) => {
							if (ValidateAll("date", date)) {
								setErrors({ ...errors, nacimiento: true });
							} else {
								let newErr = errors;
								delete newErr["nacimiento"];
								setErrors(newErr);
							}
							setCurrentBenef({ ...current, nacimiento: date });
						}}
					/>
				</div>
			</div>
			<br />
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Género</label>
					<div sytle={{ width: "100%" }}>
						<div className='custom-radio d-inline-block'>
							<input
								type='radio'
								id='id-gender-benef-f'
								name='id_gender_benef'
								value={"2"}
								checked={current?.id_gender == "2"}
								onChange={handleUpdateBeneficiario}
							/>
							<label htmlFor='id-gender-benef-f' style={{ color: "white" }}>
								Fem.
							</label>
						</div>
						&nbsp;&nbsp;
						<div className='custom-radio d-inline-block ml-masc'>
							<input
								type='radio'
								id='id-gender-benef-m'
								name='id_gender_benef'
								value={"1"}
								checked={current?.id_gender == "1"}
								onChange={handleUpdateBeneficiario}
							/>
							<label htmlFor='id-gender-benef-m' style={{ color: "white" }}>
								Masc.
							</label>
						</div>
					</div>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Parentesco</label>
					{relatedToYou ? (
						<div sytle={{ width: "100%" }}>
							<div className='custom-radio d-inline-block'>
								<input
									type='radio'
									id='id-cus-parents-hijo'
									name='id_cus_parents'
									value={"4"}
									checked={current?.id_cus_parents == "4"}
									onChange={handleUpdateBeneficiario}
								/>
								<label htmlFor='id-cus-parents-hijo' style={{ color: "white" }}>
									Hijo(s)
								</label>
							</div>
							&nbsp;&nbsp;
							<div className='custom-radio d-inline-block ml-masc'>
								<input
									type='radio'
									id='id-cus-parents-cony'
									name='id_cus_parents'
									value={"5"}
									checked={current?.id_cus_parents == "5"}
									onChange={handleUpdateBeneficiario}
								/>
								<label htmlFor='id-cus-parents-cony' style={{ color: "white" }}>
									Cónyuge
								</label>
							</div>
						</div>
					) : (
						<input
							className='form-control'
							type='text'
							name='id_cus_parents'
							style={errors?.id_cus_parents ? { borderColor: "red" } : {}}
							onChange={handleUpdateBeneficiario}
							value={current.id_cus_parents}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
const Step1 = ({
	errors,
	data,
	formChangeHandler,
	setData,
	onClickHandler,
	type,
	ProcessToQuote,
	setConfirmModal,
}) => {
	return (
		<>
			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Nombre</label>
					<input
						className='form-control'
						type='text'
						name='name'
						style={errors?.name ? { borderColor: "red" } : {}}
						value={data?.name}
						onChange={formChangeHandler}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Correo electrónico</label>
					<input
						className='form-control'
						type='text'
						name='e_mail'
						style={errors?.e_mail ? { borderColor: "red" } : {}}
						value={data?.e_mail}
						onChange={formChangeHandler}
					/>
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Fecha de Nacimiento</label>
					<Calendario
						error={errors?.birthday}
						value={data?.birthday}
						handleChange={(date) =>
							setData({
								...data,
								nacimiento: date,
								birthday: date,
							})
						}
					/>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Teléfono</label>
					<input
						className='form-control'
						name='phone'
						maxLength={10}
						style={errors?.phone ? { borderColor: "red" } : {}}
						value={data?.phone}
						onChange={formChangeHandler}
					/>
				</div>
			</div>

			<div className='row'>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Género*</label>
					<div sytle={{ width: "100%" }}>
						<div className='custom-radio d-inline-block'>
							<input
								type='radio'
								id={type + "fem"}
								name='id_gender'
								value={2}
								checked={data?.id_gender == 2}
								onChange={formChangeHandler}
							/>
							<label htmlFor={type + "fem"} style={{ color: "white" }}>
								Fem.
							</label>
						</div>
						<div className='custom-radio d-inline-block ml-masc'>
							<input
								type='radio'
								id={type + "masc"}
								name='id_gender'
								value={1}
								checked={data?.id_gender == 1}
								onChange={formChangeHandler}
							/>
							<label htmlFor={type + "masc"} style={{ color: "white" }}>
								Masc.
							</label>
						</div>
					</div>
				</div>
				<div className='col-sm-12 col-md-6'>
					<label style={{ color: "white" }}>Código Postal</label>
					<input
						className='form-control'
						type='number'
						maxLength={5}
						name='zip_code'
						value={data?.zip_code}
						style={errors?.zip_code ? { borderColor: "red" } : {}}
						onChange={formChangeHandler}
					/>
				</div>
			</div>

			{type == "accident" && (
				<div className='row'>
					<div className='col-md-6 col-md-6'></div>
					<div className='col-xl-6 col-md-6'>
						<label style={{ color: "white" }}>Suma Asegurada</label>
						<div className='custom-select-container'>
							<select
								className='form-control'
								name='suma_asegurada'
								style={errors?.suma_asegurada ? { borderColor: "red" } : {}}
								value={data?.suma_asegurada}
								onChange={(e) =>
									setData({ ...data, suma_asegurada: e.target.value })
								}>
								<option value={0} disabled selected>
									Seleccione
								</option>
								{[50000, 100000, 200000, 300000, 500000]?.map((item) => (
									<option
										selected={item === data?.suma_asegurada}
										key={item}
										value={item}>
										{item}
									</option>
								))}
							</select>
							<span className='custom-arrow'></span>
						</div>
					</div>
				</div>
			)}

			{(type == "medical-expense-group" || type == "company_accident") && (
				<div className='row'>
					<div className='col-sm-12 col-md-6'>
						<label style={{ color: "white" }}>Persona</label>
						<div sytle={{ width: "100%" }}>
							<div className='custom-radio d-inline-block'>
								<input
									type='radio'
									id='fis'
									name='physical_person'
									value='1'
									checked={data?.physical_person == 1}
									onChange={formChangeHandler}
								/>
								<label htmlFor='fis' style={{ color: "white" }}>
									Física
								</label>
							</div>
							<div className='custom-radio d-inline-block ml-masc'>
								<input
									type='radio'
									id='mor'
									name='physical_person'
									value='0'
									checked={data?.physical_person == 0}
									onChange={formChangeHandler}
								/>
								<label htmlFor='mor' style={{ color: "white" }}>
									Moral
								</label>
							</div>
						</div>
					</div>
					{data?.physical_person == 0 && (
						<div className='col-sm-12 col-md-6'>
							<label style={{ color: "white" }}>Razón Social</label>
							<input
								className='form-control'
								type='text'
								name='business_name'
								style={errors?.business_name ? { borderColor: "red" } : {}}
								value={data?.business_name}
								onChange={formChangeHandler}
							/>
						</div>
					)}
				</div>
			)}
			{(type == "medical-expense" || type == "medical-expense-group") && (
				<div className='row'>
					<div className='col-sm-12 col-md-6'>
						<label style={{ color: "white" }}>Tipo de seguro</label>
						<div className='custom-select-container'>
							<select
								className='form-control'
								name='tipo_seguro'
								style={errors?.tipo_seguro ? { borderColor: "red" } : {}}
								value={data?.tipo_seguro}
								onChange={(e) =>
									setData({ ...data, tipo_seguro: e.target.value })
								}>
								<option value={""} disabled selected>
									Seleccione
								</option>
								{["Nacional", "Internacional"]?.map((opt, index) => (
									<option
										key={opt}
										value={index}
										selected={index === data?.tipo_seguro}>
										{opt}
									</option>
								))}
							</select>
							<span className='custom-arrow'></span>
						</div>
					</div>
					{type == "medical-expense" && (
						<div className='col-sm-12 col-md-6'>
							<label style={{ color: "white" }}>¿El seguro es para ti?</label>
							<div sytle={{ width: "100%" }}>
								<div className='custom-radio d-inline-block'>
									<input
										type='radio'
										id={type + "si5"}
										name='el_seguro'
										value={1}
										checked={data?.el_seguro == 1}
										onChange={formChangeHandler}
									/>
									<label htmlFor={type + "si5"} style={{ color: "white" }}>
										Sí
									</label>
								</div>
								<div className='custom-radio d-inline-block ml-masc'>
									<input
										type='radio'
										id={type + "no5"}
										name='el_seguro'
										value={2}
										checked={data?.el_seguro == 2}
										onChange={formChangeHandler}
									/>
									<label htmlFor={type + "no5"} style={{ color: "white" }}>
										No
									</label>
								</div>
							</div>
						</div>
					)}
					<div className='col-sm-12 col-md-6'>
						<label style={{ color: "white" }}>Alias</label>
						<input
							className='form-control'
							type='text'
							name='alias'
							style={errors?.alias ? { borderColor: "red" } : {}}
							value={data?.alias}
							onChange={formChangeHandler}
						/>
					</div>
				</div>
			)}
			<div className='row'>
				<div className='col-sm-12 text-center'>
					<Button
						onClick={async () => {
							const success = onClickHandler();
							if (success) {
								if (type == "medical-expense") {
									return setConfirmModal(true);
								}
								await ProcessToQuote();
							}
						}}>
						Siguiente
					</Button>
				</div>
			</div>
		</>
	);
};

export default AccidentForm;

const Title = styled.p`
	font-size: 40px;
	color: white;

	@media (max-width: 768px) {
		font-size: 24px;
		margin-bottom: 0px;
	}
`;

const Tabs = styled.p`
	font-size: 29px;
	color: white;
	width: 20px;
	cursor: pointer;
	&:first-child {
		margin-right: 12px;
	}
`;

export const Button = styled.button`
	background: #f89900;
	border: 3px solid white;
	color: white;
	text-align: center;

	padding: 11px;
	border-radius: 100px;
	width: 200px;
	margin-top: 10%;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 7%;
`;

const TableWrapper = styled(Table)`
	max-height: 600px;
	overflow-y: scroll;
	tr {
		border-bottom: 1px solid lightgray;
	}
	td {
		vertical-align: middle !important;
	}
`;

export const Wrapper = styled.section`
	align-items: center;
	min-height: 550px;
	background: #5a68a1;
	border-radius: 20px;
	height: auto;
	margin-left: auto;
	margin-right: auto;
	height: auto;
	@media (max-width: 768px) {
		margin-top: 17%;
	}

	.form-group {
		display: block;
		margin-bottom: 15px;

		@media (max-width: 768px) {
			margin-bottom: 5px;
		}
	}

	.form-group input {
		padding: 0;
		height: initial;
		width: initial;
		margin-bottom: 0;
		display: none;
		cursor: pointer;
	}

	.form-group label {
		position: relative;
		cursor: pointer;
		color: white;
	}

	.form-group label:before {
		content: "";
		-webkit-appearance: none;
		background-color: transparent;
		border: 2px solid white;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
			inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
		padding: 10px;
		display: inline-block;
		position: relative;
		vertical-align: middle;
		cursor: pointer;
		margin-right: 5px;
	}

	.form-group input:checked + label:after {
		content: "";
		display: block;
		position: absolute;
		top: 2px;
		left: 9px;
		width: 6px;
		height: 14px;
		border: solid #0079bf;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	[type="radio"]:checked,
	[type="radio"]:not(:checked) {
		position: absolute;
		left: -9999px;
	}
	[type="radio"]:checked + label,
	[type="radio"]:not(:checked) + label {
		position: relative;
		padding-left: 28px;
		cursor: pointer;
		line-height: 20px;
		display: inline-block;
		color: #666;
	}
	[type="radio"]:checked + label:before,
	[type="radio"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		width: 18px;
		height: 18px;
		border: 1px solid #ddd;
		border-radius: 100%;
		background: #fff;
	}
	[type="radio"]:checked + label:after,
	[type="radio"]:not(:checked) + label:after {
		content: "";
		width: 18px;
		height: 18px;
		border: 2px solid white;
		background: #3cdbc0;
		position: absolute;

		border-radius: 100%;
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
	[type="radio"]:not(:checked) + label:after {
		opacity: 0;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	[type="radio"]:checked + label:after {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
		left: 0;
	}
	.select.form-control {
		color: black;
	}

	.disabled {
		select {
			opacity: 0.8 !important;
		}
	}
`;
